<h1 class="stock-title">Dealer Summary</h1>

<br />
<div *ngIf="dealerSummary">
  <h2>{{ dealerSummary?.name1 || ''}} - {{ dealerSummary?.dealcode || ''}}</h2>

  <br>
  <ds-box>
    <ds-box-content>
      <br>
<!--      <div class="styled-section">-->
        <div class="table-section">
          <div class="table-scroll-container">
            <table class="ds-table zebra-table fixed-header-table">
              <thead>
              <tr class="table_head">
                <th>Description</th>
                <th>Status</th>
                <th>Total</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let item of dealerSummary.zover">
                <td>{{ item.description }}</td>
                <td>
                 <span>
                   <ds-icon
                     icon="circle_filled"
                     size="xs"
                     [tone]="item.irobot === 'R' ? 'critical' : item.irobot === 'G' ? 'positive' : 'neutral'">
                   </ds-icon>
                   <span style="margin: 5px">
                     {{ item.irobot === 'R' ? 'Critical' : item.irobot === 'G' ? 'Positive' : item.irobot }}
                   </span>
                 </span>
                </td>
                <td>{{ item.total | number:'1.0-0' }}</td>
                <td>
                  <ds-icon
                    icon="eye"
                    size="md"
                    style="color: #037493;cursor: pointer "
                    [title]="'View details for ' + item.description"
                    class="action transfer"
                    (click)="getData(item.zseq,item.description,item.total)"
                    (keydown)="console.log(item);

                            "
                  ></ds-icon>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
<!--      </div>-->
    </ds-box-content>
  </ds-box>

</div>

<ds-modal #summaryModal
          [dimensionsConfig]="{ width: '900px', height: '500px' }"
          [ds-modal-trigger-for]="summaryModal"
          [(isModalOpen)]="summaryModalIsOpen"
          [detachFooter]="true">
  <ds-box-header style="font-size: xx-large; font-weight: bold">
    <h2>{{ summaryModalData.title }}</h2>
    <h3>{{ dealerSummary?.name1 }} - {{ dealerSummary?.dealcode }}</h3>
  </ds-box-header>
  <ds-box-content>
    <div class="search-section" style="display: flex; align-items: center; gap: 12px; margin-bottom: 16px;">
      <label for="searchInput" style="font-weight: 500; margin-bottom: 0;">
        Search:
      </label>
      <input
        id="searchInput"
        type="text"
        [(ngModel)]="searchText"
        placeholder="Type to search..."
        class="form-control"
        style="border-radius: 2px; border: 1px solid #037493; padding: 6px 12px; width: 250px; font-size: 15px;"
      />
    </div>
    <div class="table-section">
      <div class="table-scroll-container">
        <table class="ds-table zebra-table fixed-header-table">
          <thead>
          <tr class="table_head">
            <th *ngFor="let column of getTableHeaders(currentZseq)">
              {{ column.headerName }}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let row of filteredRowsData">
            <td *ngFor="let column of getTableHeaders(currentZseq)">
              <ng-container *ngIf="column.field === 'action'; else unitUpdate">

                  <ds-icon
                    icon="exchange_box"
                    size="sm"
                    style="color: #037493; cursor: pointer;"
                    title="Transfer back to Camp"
                    (click)="callTransfer(row['zbody'],row['vin'])"></ds-icon>


              </ng-container>

              <ng-template #unitUpdate>
                <ng-container  *ngIf="column.field === 'zorder'; else defaultContent">
                <a
                  style="
                  font-weight: bold;
                  color: #037493;
                  text-decoration: none;
                  cursor: pointer;"
                  title="Unit Update"
                  href="/unit-update?vin={{ row['vin'] }}&bodyNo={{ row['zbody'] }}"
                  target="_blank"
                  rel="noopener"
                >
                  {{ row[column.field] }}
                </a>
                </ng-container>
              </ng-template>
              <ng-template #defaultContent>
                <ng-container *ngIf="column.field === 'zbody'; else defaultCell">
                  <a
                    [href]="row[column.field] | unitOverviewLink"
                    target="_blank"
                    rel="noopener"
                    style="
                  font-weight: bold;
                  color: #037493;
                  text-decoration: none;
                  cursor: pointer;"
                    title="View Unit Overview"
                  >
                    {{ row[column.field] }}
                  </a>
                </ng-container>
              </ng-template>

              <ng-template #defaultCell>
                {{ row[column.field] }}
              </ng-template>

            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ds-box-content>
  <ds-box-footer>
    <button
      ds-button
      variant="primary"
      (click)="onModalClose()"
    >
      Close
    </button>

  </ds-box-footer>
</ds-modal>
<ds-modal #holdsTransferModal
          [dimensionsConfig]="{ width: '800px', height: '700px' }"
          [ds-modal-trigger-for]="holdsTransferModal"
          [(isModalOpen)]="holdsTransferModalIsOpen"
          [detachFooter]="true"
>

  <ds-box-header>
    <h2>Holds and Transfers</h2>
  </ds-box-header>
  <ds-box-content>
    <div>
      Holds- and Transfer Requests -
      {{ holdTransfermodalData.dealerName }} ({{ holdTransfermodalData.dealerCode }})
    </div>

    <br>
    <ds-accordion activeItemId="accordion-item1">
      <ds-accordion-item id="accordion-item1">
        Requests from other dealers that you must approve/invoice/reject
        <div content>
          <div class="data-section">
            <div content class="accordion-content">
              <div *ngIf="dealerTransfersResponse?.zpend1.length > 0; else noRequests">
                <table class="ds-table zebra-table fixed-header-table">
                  <thead>
                  <tr class="table_head">
                    <th>Body No</th>
                    <th>From Dealer</th>
                    <th>To Dealer</th>
                    <th>Requested By</th>
                    <th>On</th>
                    <th>At</th>
                    <th>Status</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let item of dealerTransfersResponse?.zpend1; let i = index"
                      [attr.id]="'tr' + item.zbody"
                  >
                    <td>
                      {{ item.zbody }}
                    </td>
                    <td>{{ item.dlrfrom }}</td>
                    <td>{{ item.dlrto }}</td>
                    <td>{{ item.name1 }}</td>
                    <td>{{ item.reqdate }}</td>
                    <td>{{ item.reqtime }}</td>
                    <td>{{ item.stxt }}</td>
                    <td></td>
                    <td>
                      <ng-container *ngIf="z11GetUserDetailResponse?.dlr_update ==='X' && item.zstatus === ''">
                        <ng-container
                          *ngIf="z11GetUserDetailResponse?.brand3 ==='MOTORCYCLE' && item.zinvind !== 'Stock'; else rejectIcon">
                          Invoice Unit
                        </ng-container>
                        <ng-template #rejectIcon>
                          Reject request
                        </ng-template>
                      </ng-container>
                      <ng-container *ngIf="z11GetUserDetailResponse?.dlr_update !=='X' || item.zstatus !== ''">
                        dontknow
                      </ng-container>
                    </td>
                    <td>
                      <ng-container *ngIf="z11GetUserDetailResponse?.dlr_update ==='X' && item.zstatus === ''">
                        approve request
                      </ng-container>
                      <ng-container *ngIf="z11GetUserDetailResponse?.dlr_update !=='X' || item.zstatus !== ''">

                      </ng-container>
                    </td>
                    <td></td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <ng-template #noRequests>
                  <span>
                    There are no requests for you to approve /
                    {{ z11GetUserDetailResponse?.brand3 === 'MOTORCYCLE' ? 'invoice' : 'reject' }}
                  </span>
              </ng-template>
            </div>
          </div>
        </div>
      </ds-accordion-item>
      <ds-accordion-item id="accordion-item2">
        Requests to other dealers waiting for approval /
        {{ z11GetUserDetailResponse?.brand3 === 'MOTORCYCLE' ? 'invoicing' : 'rejection' }}
        <div content>
          <div class="data-section">
            <div content class="accordion-content">
              <div *ngIf="dealerTransfersResponse?.zpend2.length > 0; else noRequests" style="width: 100%">
                <div class="table-section">
                  <div class="table-scroll-container">
                      <table class="ds-table zebra-table fixed-header-table" >
                        <thead>
                          <tr class="table_head">
                            <td>Body No</td>
                            <td>From Dealer</td>
                            <td>To Dealer</td>
                            <td>Requested By</td>
                            <td>On</td>
                            <td>At</td>
                            <td>Status</td>
                          </tr>
                        </thead>
                        <tbody>
                          <ng-container *ngFor="let item of dealerTransfersResponse?.zpend2; let i = index">
                            <tr (click)="onRowClick(i, item)" class="parent-row">
                             <td>

                               <ds-icon
                                 icon="arrow_right_small"
                                 [ngClass]="{ 'rotated': expandedRow === i }"
                                 size="sm"
                                 style="vertical-align: middle;margin-bottom: 5px"
                                 title="Expand row"
                               ></ds-icon>
                               <a
                                 style="font-weight: bold; color: #037493; text-decoration: none; cursor: pointer;"
                                 title="Unit Update"
                                 href="/unit-update?vin={{ item.vin }}&bodyNo={{ item.zbody }}"
                                 target="_blank"
                                 rel="noopener"
                               >
                                 {{ item.zbody }}
                               </a>
                             </td>
                              <td>{{ item.dlrfrom }}</td>
                              <td>{{ item.dlrto }}</td>
                              <td>{{ item.name1 }}</td>
                              <td>{{ item.reqdate }}</td>
                              <td>{{ item.reqtime }}</td>
                              <td>{{ item.stxt }}</td>
                            </tr>
                            <tr *ngIf="expandedRow === i" class="nested-row">
                              <td [attr.colspan]="11" colspan="11" class="p-0">
                                <div class="nested-table-container">
                                 <td colspan="59">
                                    <table 
                                         >
                                      <tr style=" background-color: #035970; vertical-align: middle; font-weight: bold; color: #ffffff;height: 14px;">
                                        <td >
                                          <span >
                                            Transfer detail for unit: {{ item.zbody }}
                                          </span>
                                        </td>
                                        <td>
                                          <span> </span>
                                        </td>
                                      </tr>
                                      <tr >
                                        <td>
                                          <span >
                                            Requesting Dealer:
                                          </span>
                                        </td>
                                        <td >
                                          <span >
                                            {{ item.dlrfrom }}
                                          </span>
                                        </td>
                                      </tr>
                                      <tr >
                                        <td >
                                          <span >
                                            Requesting User:
                                          </span>
                                        </td>
                                        <td >
                                          <span >
                                            {{ item.name1 }}
                                          </span>
                                        </td>
                                      </tr>
                                      <tr >
                                        <td >
                                          <span >
                                            Requested:
                                          </span>
                                        </td>
                                        <td >
                                          <span >
                                            {{ item.reqdate }}&#160;at&#160;{{ item.reqtime }}
                                          </span>
                                        </td>
                                      </tr>
                                      <ng-container *ngIf="item.zstatus">
                                        <tr >
                                          <td >
                                            <span >
                                              Approval / {{ z11GetUserDetailResponse?.brand3 === 'MOTORCYCLE' ? 'Invoicing' : 'Rejection' }}
                                            </span>
                                          </td>
                                          <td >
                                            <span >&#160;</span>
                                          </td>
                                        </tr>
                                        <tr >
                                          <td >
                                            <span >
                                              Dealer:
                                            </span>
                                          </td>
                                          <td >
                                            <span >
                                              {{ item.dlrto }}
                                            </span>
                                          </td>
                                        </tr>
                                        <tr >
                                          <td >
                                            <span >
                                              User:
                                            </span>
                                          </td>
                                          <td >
                                            <span >
                                              {{ item.name2 }}
                                            </span>
                                          </td>
                                        </tr>
                                        <tr >
                                          <td >
                                            <span >
                                              On:
                                            </span>
                                          </td>
                                          <td >
                                            <span >
                                              {{ item.confdate }}&#160;at&#160;{{ item.conftime }}
                                            </span>
                                          </td>
                                        </tr>
                                        <tr >
                                          <td >
                                            <span >
                                              Reason:
                                            </span>
                                          </td>
                                          <td >
                                            <span >
                                              {{ item.zreason }}
                                            </span>
                                          </td>
                                        </tr>
                                      </ng-container>
                                      <tr style=" background-color: #035970; vertical-align: middle; font-weight: bold; color: #ffffff;height: 14px;">
                                        <td >
                                          <span style="width:300px;text-align: left; padding-left:7px;">
                                            Vehicle Details
                                          </span>
                                        </td>
                                        <td >
                                          <span >&#160;</span>
                                        </td>
                                      </tr>
                                      <tr >
                                        <td >
                                          <span >
                                            Body Number:
                                          </span>
                                        </td>
                                        <td >
                                          <span >
                                            {{ item.zbody }}
                                          </span>
                                        </td>
                                      </tr>
                                      <tr >
                                        <td >
                                          <span >
                                            Model:
                                          </span>
                                        </td>
                                        <td >
                                          <span >
                                            {{ item.modtxt }}
                                          </span>
                                        </td>
                                      </tr>
                                      <tr >
                                        <td >
                                          <span >
                                            Exterior:
                                          </span>
                                        </td>
                                        <td >
                                          <span >
                                            {{ item.exttxt }}
                                          </span>
                                        </td>
                                      </tr>
                                      <tr >
                                        <td >
                                          <span >
                                            Interior:
                                          </span>
                                        </td>
                                        <td >
                                          <span >
                                            {{ item.inttxt }}
                                          </span>
                                        </td>
                                      </tr>
                                    </table>
                                  </td>
                                </div>
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                  </div>
                </div>
              </div>
              <ng-template #noRequests>
    <span>
     No requests waiting to be approved /
      {{ z11GetUserDetailResponse?.brand3 === 'MOTORCYCLE' ? 'invoice' : 'reject' }} by other dealers

    </span>
              </ng-template>
            </div>
          </div>
        </div>
      </ds-accordion-item>
      <ds-accordion-item id="accordion-item3">
        Holds
        <div content>
          <div class="data-section">
            <div content class="accordion-content">
              <div *ngIf="dealerTransfersResponse?.holds?.length > 0; else noHolds">
                <tr>
                  <td>
                    <table>
                      <tr>
                        <td>Body No</td>
                        <td>Model</td>
                        <td>Exterior</td>
                        <td>Interior</td>
                        <td>Held On</td>
                        <td>Held At</td>
                        <td>Held By</td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr *ngFor="let item of dealerTransfersResponse?.holds; let i = index"
                          [style.height.px]="16"
                          [style.backgroundColor]="i % 2 === 0 ? '#FFFFFF' : '#E6E6E6'"
                          [attr.id]="'hold' + item.zbody">
                        <td>{{ item.zbody }}</td>
                        <td>{{ item.modtxt }}</td>
                        <td>{{ item.extcode }}</td>
                        <td>{{ item.intcode }}</td>
                        <td>{{ item.zholddte }}</td>
                        <td>{{ item.zholdtme }}</td>
                        <td>{{ item.name1 }}</td>
                        <td style="width:23px;">

                          delete hold
                        </td>
                        <td style="width:69px;">&#160;</td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </div>
              <ng-template #noHolds>
                <tr>
                  <td>
      <span>
        Your dealer does not have any holds
      </span>
                  </td>
                </tr>
              </ng-template>
            </div>
          </div>
        </div>
      </ds-accordion-item>
    </ds-accordion>

  </ds-box-content>
  <ds-box-footer >
    <button
      ds-button
      variant="primary"
      (click)="onHoldsTransferModalClose()"
    >
      Close
    </button>
  </ds-box-footer>
</ds-modal>

<ds-modal #summaryDeallocationModal
          [dimensionsConfig]="{ width: '900px', height: '500px' }"
          [ds-modal-trigger-for]="summaryDeallocationModal"
          [(isModalOpen)]="summaryDeallocationModalIsOpen"
          [detachFooter]="true">
  <ds-box-header style="font-size: xx-large; font-weight: bold">
    <h2>{{ summaryModalData.title }}</h2>
    <h3>{{ dealerSummary?.name1 }} - {{ dealerSummary?.dealcode }}</h3>
  </ds-box-header>
  <ds-box-content>
    <div class="search-section" style="display: flex; align-items: center; gap: 12px; margin-bottom: 16px;">
      <label for="searchInput" style="font-weight: 500; margin-bottom: 0;">
        Search:
      </label>
      <input
        id="searchInput"
        type="text"
        [(ngModel)]="searchText"
        placeholder="Type to search..."
        class="form-control"
        style="border-radius: 2px; border: 1px solid #037493; padding: 6px 12px; width: 250px; font-size: 15px;"
      />
    </div>
    <div class="table-section">
      <div class="table-scroll-container">
        <table class="ds-table zebra-table fixed-header-table">
          <thead>
          <tr class="table_head">
            <th>Order Number</th>
            <th>Body Number</th>
            <th>Model Code</th>
            <th>Dealer Code</th>
            <th>DC</th>
            <th>SC</th>
            <th>Production Week</th>
            <th>OTP</th>
            <th>De-allocation Date</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let row of filteredRowsData">
            <td>
              <a
                style="
                  font-weight: bold;
                  color: #037493;
                  text-decoration: none;
                  cursor: pointer;"
                title="Unit Update"
                href="/unit-update?vin={{ row['vin'] }}&bodyNo={{ row['zbody'] }}"
                target="_blank"
                rel="noopener"
              >
                {{ row['zorder'] }}
              </a>
              </td>
            <td>
              <a
                [href]="row['zbody'] | unitOverviewLink"
                target="_blank"
                rel="noopener"
                style="
                  font-weight: bold;
                  color: #037493;
                  text-decoration: none;
                  cursor: pointer;"
                title="View Unit Overview"
              >
                {{ row['zbody'] }}
              </a>

             </td>
            <td>{{ row['zmodel'] }}</td>
            <td>{{ row['z08dlr'] }}</td>
            <td>{{ row['zdes_cde'] }}</td>
            <td>{{ row['stat_code'] }}</td>
            <td>{{ row['zprodw'] }}</td>
            <td>{{ row['zotp'] }}</td>
            <td>{{ row['zdeall_dte'] }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ds-box-content>
  <ds-box-footer>
    <button
      ds-button
      variant="primary"
      (click)="onDeallocationModalClose()"
    >
      Close
    </button>

  </ds-box-footer>
</ds-modal>
<ds-modal #summaryDeallocationFiveDaysModal
          [dimensionsConfig]="{ width: '900px', height: '500px' }"
          [ds-modal-trigger-for]="summaryDeallocationFiveDaysModal"
          [(isModalOpen)]="summaryDeallocationFiveDaysModalIsOpen"
          [detachFooter]="true">
  <ds-box-header style="font-size: xx-large; font-weight: bold">
    <h2>{{ summaryModalData.title }}</h2>
    <h3>{{ dealerSummary?.name1 }} - {{ dealerSummary?.dealcode }}</h3>
  </ds-box-header>
  <ds-box-content>
    <div class="search-section" style="display: flex; align-items: center; gap: 12px; margin-bottom: 16px;">
      <label for="searchInput" style="font-weight: 500; margin-bottom: 0;">
        Search:
      </label>
      <input
        id="searchInput"
        type="text"
        [(ngModel)]="searchText"
        placeholder="Type to search..."
        class="form-control"
        style="border-radius: 2px; border: 1px solid #037493; padding: 6px 12px; width: 250px; font-size: 15px;"
      />
    </div>
    <div class="table-section">
      <div class="table-scroll-container">
        <table class="ds-table zebra-table fixed-header-table">
          <thead>
          <tr class="table_head">
            <th>Order Number</th>
            <th>Body Number</th>
            <th>Model Code</th>
            <th>Dealer Code</th>
            <th>DC</th>
            <th>SC</th>
            <th>Production Week</th>
            <th>OTP</th>
            <th>De-allocation Date</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let row of filteredRowsData">
            <td>
              <a
                style="
                  font-weight: bold;
                  color: #037493;
                  text-decoration: none;
                  cursor: pointer;"
                title="Unit Update"
                href="/unit-update?vin={{ row['vin'] }}&bodyNo={{ row['zbody'] }}"
                target="_blank"
                rel="noopener"
              >
                {{ row['zorder'] }}
              </a>
            </td>
            <td>
              <a
                [href]="row['zbody'] | unitOverviewLink"
                target="_blank"
                rel="noopener"
                style="
                  font-weight: bold;
                  color: #037493;
                  text-decoration: none;
                  cursor: pointer;"
                title="View Unit Overview"
              >
                {{ row['zbody'] }}
              </a>

            </td>
            <td>{{ row['zmodel'] }}</td>
            <td>{{ row['z08dlr'] }}</td>
            <td>{{ row['zdes_cde'] }}</td>
            <td>{{ row['stat_code'] }}</td>
            <td>{{ row['zprodw'] }}</td>
            <td>{{ row['zotp'] }}</td>
            <td>{{ row['zdeall_dte'] }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ds-box-content>
  <ds-box-footer>
    <button
      ds-button
      variant="primary"
      (click)="onDeallocationFiveDaysModalClose()"
    >
      Close
    </button>

  </ds-box-footer>
</ds-modal>
<ds-modal #summaryInvoicingReadyModal
          [dimensionsConfig]="{ width: '900px', height: 'auto' }"
          [ds-modal-trigger-for]="summaryInvoicingReadyModal"
          [(isModalOpen)]="summaryInvoicingReadyModalIsOpen"
          [detachFooter]="true">
  <ds-box-header style="font-size: xx-large; font-weight: bold">
    <h2>{{ summaryModalData.title }}</h2>
    <h3>{{ dealerSummary?.name1 }} - {{ dealerSummary?.dealcode }}</h3>
  </ds-box-header>
  <ds-box-content>
    <div class="search-section" style="display: flex; align-items: center; gap: 12px; margin-bottom: 16px;">
      <label for="searchInput" style="font-weight: 500; margin-bottom: 0;">
        Search:
      </label>
      <input
        id="searchInput"
        type="text"
        [(ngModel)]="searchText"
        placeholder="Type to search..."
        class="form-control"
        style="border-radius: 2px; border: 1px solid #037493; padding: 6px 12px; width: 250px; font-size: 15px;"
      />
    </div>
    <div class="table-section">
      <div class="table-scroll-container">
        <table class="ds-table zebra-table fixed-header-table">
          <thead>
          <tr class="table_head">
            <th>Order Number</th>
            <th>Body Number</th>
            <th>RFI Date</th>
            <th>Model Code</th>
            <th>Interior Code</th>
            <th>Exterior Code</th>
            <th>OTP</th>
            <th>De-allocation Date</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let row of filteredRowsData">
            <td>
              <a
                style="
                  font-weight: bold;
                  color: #037493;
                  text-decoration: none;
                  cursor: pointer;"
                title="Unit Update"
                href="/unit-update?vin={{ row['vin'] }}&bodyNo={{ row['zbody'] }}"
                target="_blank"
                rel="noopener"
              >
                {{ row['zorder'] }}
              </a>
            </td>
            <td>
              <a
                [href]="row['zbody'] | unitOverviewLink"
                target="_blank"
                rel="noopener"
                style="
                  font-weight: bold;
                  color: #037493;
                  text-decoration: none;
                  cursor: pointer;"
                title="View Unit Overview"
              >
                {{ row['zbody'] }}
              </a>
            </td>
            <td>{{ row['zact_dte'] }}</td>
            <td>{{ row['zmodel'] }}</td>
            <td>{{ row['zcol'] }}</td>
            <td>{{ row['ztrim'] }}</td>
            <td>{{ row['zotp'] }}</td>
            <td>{{ row['zdeall_dte'] }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ds-box-content>
  <ds-box-footer>
    <button
      ds-button
      variant="primary"
      (click)="onInvoicingModalClose()"
    >
      Close
    </button>

  </ds-box-footer>
</ds-modal>
<ds-modal #summaryInvoiceRejectedModal
          [dimensionsConfig]="{ width: '900px', height: 'auto' }"
          [ds-modal-trigger-for]="summaryInvoiceRejectedModal"
          [(isModalOpen)]="summaryInvoiceRejectedModalIsOpen"
          [detachFooter]="true">
  <ds-box-header style="font-size: xx-large; font-weight: bold">
    <h2>{{ summaryModalData.title }}</h2>
    <h3>{{ dealerSummary?.name1 }} - {{ dealerSummary?.dealcode }}</h3>
  </ds-box-header>
  <ds-box-content>
    <div class="search-section" style="display: flex; align-items: center; gap: 12px; margin-bottom: 16px;">
      <label for="searchInput" style="font-weight: 500; margin-bottom: 0;">
        Search:
      </label>
      <input
        id="searchInput"
        type="text"
        [(ngModel)]="searchText"
        placeholder="Type to search..."
        class="form-control"
        style="border-radius: 2px; border: 1px solid #037493; padding: 6px 12px; width: 250px; font-size: 15px;"
      />
    </div>
    <div class="table-section">
      <div class="table-scroll-container">
        <table class="ds-table zebra-table fixed-header-table">
          <thead>
          <tr class="table_head">
            <th>Order Number</th>
            <th>Body Number</th>
            <th>Model Code</th>
            <th>Invoice Date</th>
            <th>Dealer Code</th>
            <th>DC</th>
            <th>SC</th>
            <th>Production Week</th>
            <th>OTP</th>
            <th>De-allocation Date</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let row of filteredRowsData">
            <td>
              <a
                style="
                  font-weight: bold;
                  color: #037493;
                  text-decoration: none;
                  cursor: pointer;"
                title="Unit Update"
                href="/unit-update?vin={{ row['vin'] }}&bodyNo={{ row['zbody'] }}"
                target="_blank"
                rel="noopener"
              >
                {{ row['zorder'] }}
              </a>
            </td>
            <td>
              <a
                [href]="row['zbody']| unitOverviewLink"
                target="_blank"
                rel="noopener"
                style="
                  font-weight: bold;
                  color: #037493;
                  text-decoration: none;
                  cursor: pointer;"
                title="View Unit Overview"
              >
                {{ row['zbody'] }}
              </a>
            </td>
            <td>{{ row['zmodel'] }}</td>
            <td>{{ row['zmodel'] }}</td>
            <td>{{ row['z08dlr'] }}</td>
            <td>{{ row['zdes_cde'] }}</td>
            <td>{{ row['stat_code'] }}</td>
            <td>{{ row['zprodw'] }}</td>
            <td>{{ row['zotp'] }}</td>
            <td>{{ row['zdeall_dte'] }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ds-box-content>
  <ds-box-footer>
    <button
      ds-button
      variant="primary"
      (click)="onInvoiceRejectedModalClose()"
    >
      Close
    </button>

  </ds-box-footer>
</ds-modal>
<ds-modal #doubleZeroNineModal
          [dimensionsConfig]="{ width: '900px', height: 'auto' }"
          [ds-modal-trigger-for]="doubleZeroNineModal"
          [(isModalOpen)]="doubleZeroNineModalIsOpen"
          [detachFooter]="true">
  <ds-box-header style="font-size: xx-large; font-weight: bold">
    <h2>{{ summaryModalData.title }}</h2>
    <h3>{{ dealerSummary?.name1 }} - {{ dealerSummary?.dealcode }}</h3>
  </ds-box-header>
  <ds-box-content>
    <div class="search-section" style="display: flex; align-items: center; gap: 12px; margin-bottom: 16px;">
      <label for="searchInput" style="font-weight: 500; margin-bottom: 0;">
        Search:
      </label>
      <input
        id="searchInput"
        type="text"
        [(ngModel)]="searchText"
        placeholder="Type to search..."
        class="form-control"
        style="border-radius: 2px; border: 1px solid #037493; padding: 6px 12px; width: 250px; font-size: 15px;"
      />
    </div>
    <div class="table-section">
      <div class="table-scroll-container">
        <table class="ds-table zebra-table fixed-header-table">
          <thead>
          <tr class="table_head">

            <th></th>
            <th>Order Number</th>
            <th>Body Number</th>
            <th>Model Code</th>
            <th>Invoice Date</th>
            <th>Dealer Code</th>
            <th>DC</th>
            <th>SC</th>
            <th>Production Week</th>
            <th>OTP</th>
            <th>De-allocation Date</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let row of filteredRowsData">
            <td>
              <ds-icon
                icon="exchange"
                size="md"
                style="color: #037493; cursor: pointer;"
                title="Transfer back to Camp"
                (click)="callTransfer(row['zbody'],row['zvin'])"></ds-icon>

            </td>
            <td>
              <a
                style="
                  font-weight: bold;
                  color: #037493;
                  text-decoration: none;
                  cursor: pointer;"
                title="Unit Update"
                href="/unit-update?vin={{ row['vin'] }}&bodyNo={{ row['zbody'] }}"
                target="_blank"
                rel="noopener"
              >
                {{ row['zorder'] }}
              </a>
            </td>
            <td>
              <a
                [href]="row['zbody'] | unitOverviewLink"
                target="_blank"
                rel="noopener"
                style="
                  font-weight: bold;
                  color: #037493;
                  text-decoration: none;
                  cursor: pointer;"
                title="View Unit Overview"
              >
                {{ row['zbody'] }}
              </a>
            </td>
            <td>{{ row['zmodel'] }}</td>
            <td>{{ row['zmodel'] }}</td>
            <td>{{ row['z08dlr'] }}</td>
            <td>{{ row['zdes_cde'] }}</td>
            <td>{{ row['stat_code'] }}</td>
            <td>{{ row['zprodw'] }}</td>
            <td>{{ row['zotp'] }}</td>
            <td>{{ row['zdeall_dte'] }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ds-box-content>
  <ds-box-footer>
    <button
      ds-button
      variant="primary"
      (click)="onDoubleZeroNineModalClose()"
    >
      Close
    </button>

  </ds-box-footer>
</ds-modal>
<ds-modal #confirmationModal
          [dimensionsConfig]="{ width: '500px', height: 'auto' }"
          [ds-modal-trigger-for]="confirmationModal"
          [(isModalOpen)]="confirmationModalIsOpen"
          [detachFooter]="true">
  <ds-box-header style="font-size: xx-large; font-weight: bold">
    Confirm
  </ds-box-header>
  <ds-box-content>
    <div class="confirmation-message" style="margin-bottom: 16px;">
      Are you sure you want to transfer body number {{ modalData.bodyNumberToTransfer }} back to camp?
    </div>
  </ds-box-content>
  <ds-box-footer>
    <button
      ds-button
      variant="outline"
      style="margin-right: 5px"
      (click)="cancelTransferModalClose()"
    >
      Cancel
    </button>
    <button
      ds-button
      variant="primary"
      (click)="confirmTransfer(modalData.bodyNumberToTransfer, modalData.vinToTransfer)"
    >
      Confirm
    </button>

  </ds-box-footer>
</ds-modal>
